import { Container, Row, Col, Card, Button, ButtonGroup, Dropdown, ButtonToolbar } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import DeckManager from 'src/DeckManager';
import ImageModal from 'src/components/ImageModal';
import PrintConfirmationModal from 'src/components/PrintConfirmationModal';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ShareDeck = () => {
  const navigate = useNavigate();
  const initialStates = {
    deck: [],
  };
  const [modalPrintConfirmationShow, setModalPrintConfirmationShow] = React.useState(false);
  const [modalImageShow, setModalImageShow] = React.useState(false);
  const [modalImageSrc, setModalImageSrc] = React.useState("");
  const [deck, setDeck] = React.useState(initialStates.deck);

  const goToMainPage = () => {
    navigate("/");
  };

  // Export as PDF
  const exportAsPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Deck Export", 10, 10);
    let y = 20;
    const typeOrder = ["seal", "mystic", "heart"];
    const sortedDeck = [...deck].sort((a, b) => {
      const aIndex = typeOrder.indexOf(a.type);
      const bIndex = typeOrder.indexOf(b.type);
      return aIndex - bIndex;
    });
    sortedDeck.forEach((card, index) => {
      doc.text(`${index + 1}. ${card.name} (x${card.qty})`, 10, y);
      y += 10;
      if (y > 280) {
        doc.addPage();
        y = 20;
      }
    });
    doc.save("deck.pdf");
  };

  // Export as Excel
  const exportAsExcel = () => {
    const ws = XLSX.utils.json_to_sheet(deck.map(card => ({
      Name: card.name,
      Pack: card.pack,
      ID: card.id,
      Type: card.type,
      Quantity: card.qty
    })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Deck");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "deck.xlsx");
  };

  useEffect(() => {
    const data = new URLSearchParams(window.location.search).get('data');
    if (data) {
      let deck = DeckManager.import(data);
      if (deck && Array.isArray(deck)) {
        setDeck(deck);
      }
    }
  }, []);

  const CardList = () => {
    const typeOrder = ["seal", "mystic", "heart"];
    const sortedDeck = [...deck].sort((a, b) => {
      const aIndex = typeOrder.indexOf(a.type);
      const bIndex = typeOrder.indexOf(b.type);
      return aIndex - bIndex;
    });

    return (
      <div className="cards-wrapper">
        <h5 className="text-center mb-3">
  การ์ดทั้งหมด: {sortedDeck.length} แบบ / {sortedDeck.reduce((sum, card) => sum + card.qty, 0)} ใบ
</h5>
        <Row className="deck g-3 justify-content-center">
          {sortedDeck.map(card => (
            <Col key={`${card.pack}-${card.id}`} xs={6} sm={4} md={3} lg={2} xl={1}>
              <div className="card-img-container">
                <Card.Img
                  src={`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`}
                  onClick={() => {
                    setModalImageSrc(`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`);
                    setModalImageShow(true);
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = `images/cards/unknown.jpg`;
                  }}
                />
                {card.qty > 0 && (
                  <span className="card-qty-label">x {card.qty}</span>
                )}
                <div className="card-name-overlay">{card.name}</div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  return (
    <Container fluid className="bg">
      <PrintConfirmationModal
        deck={deck}
        show={modalPrintConfirmationShow}
        onHide={() => setModalPrintConfirmationShow(false)}
      />
      <ImageModal
        show={modalImageShow}
        src={modalImageSrc}
        onClick={() => setModalImageShow(false)}
        onHide={() => setModalImageShow(false)}
      />
      <h3 className="text-center">Deck Manager - ShareDeck</h3>

      <ButtonToolbar className="d-flex justify-content-between mb-3 flex-wrap gap-2">
        <ButtonGroup>
          <Button variant="secondary" onClick={goToMainPage}>
            กลับไปหน้าหลัก
          </Button>
        </ButtonGroup>

        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-export">
            ส่งออก
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={exportAsPDF}>📄 PDF</Dropdown.Item>
            <Dropdown.Item onClick={exportAsExcel}>📊 Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </ButtonToolbar>

      <hr />
      <CardList />
      <hr />
    </Container>
  );
};

export default ShareDeck;
